export default "__VITE_ASSET__B9uOW7My__"